/* eslint-disable react-hooks/exhaustive-deps, jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  CardContent,
  // useMediaQuery,
  ListItem,
  ListItemText,
  List,
  Button,
  Skeleton,
  Snackbar,
  Alert,
  AlertTitle,
  useMediaQuery,
} from "@mui/material";
import moment from "moment";
import Image from "../Image"; // Update with the actual import path of your Image component
import { useTheme } from "../../style/theme";
import CheckIcon from "@mui/icons-material/Check";
import { useUser } from "../../hooks/Authorize";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Active = () => {
  const platformUser = useUser();
  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();

  const { mode } = useTheme();
  const [loading, setLoading] = useState(true); // New loading state
  const [subscriptions, setSubscriptionsData] = useState([]);
  const [showMessage, setShowMessage] = useState({
    show: true,
    message: "",
    severity: "",
  });

  const [cancelledLoading, setCancelledLoading] = useState(false); // New loading state

  const getSubscriptions = async () => {
    try {
      const response = await axios.get(
        `/store/subscription/active?userId=${platformUser?._id}`
      );
      const subscriptionsData = response?.data?.subscriptionHistory;
      console.log(
        "🚀 ~ getSubscriptions ~ subscriptionsData:",
        subscriptionsData
      );
      setSubscriptionsData(subscriptionsData);
    } catch (error) {
      console.error("Failed to fetch organizations:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowMessage({ show: false, message: " ", severity: "" });
  };

  const cancelledSubscriptions = async (id) => {
    try {
      setCancelledLoading(true);
      await axios.put(`/store/subscription/cancel/${id}`);
      setShowMessage({
        show: true,
        message: "Subscription cancelled successfully",
        severity: "success",
      });
      getSubscriptions();
    } catch (error) {
      setCancelledLoading(false);
      setShowMessage({
        show: true,
        message: "Error cancelled subscription",
        severity: "error",
      });
      console.error("Failed to fetch organizations:", error);
    } finally {
      setCancelledLoading(false);
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getSubscriptions();
  }, []);
  return (
    <Box
      sx={{
        paddingBottom: { xs: "60px", sm: "20px" },
      }}
    >
      <Snackbar
        open={showMessage.show}
        autoHideDuration={4000}
        onClose={handleClose}
      >
        <Alert
          severity={showMessage.severity}
          variant="filled"
          sx={{ width: "100%" }}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <AlertTitle> {showMessage.severity}</AlertTitle>
          {showMessage.message}
        </Alert>
      </Snackbar>
      <Box
        sx={{
          // width:"100vh",
          // height:"100vh",
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(4, 1fr)",
          },
          gap: 2,
          mt: 2,
          mx: 3,
        }}
      >
        {loading ? (
          Array.from({ length: 3 }).map((_, index) => (
            <Box
              key={index}
              sx={{
                borderRadius: "12px",
                p: 2,
                backgroundColor: mode === "light" ? "#fff" : "#141414",
                border: `1px solid ${mode === "light" ? "#e5e7eb" : "#2E2E2E"}`,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Skeleton
                  variant="rectangular"
                  width={100}
                  height={100}
                  sx={{ borderRadius: 2, mr: 2 }}
                  animation="pulse"
                />
                <Box sx={{ flexGrow: 1 }}>
                  <Skeleton
                    variant="text"
                    width="70%"
                    height={30}
                    animation="pulse"
                  />
                  <Skeleton
                    variant="text"
                    width="50%"
                    height={20}
                    animation="pulse"
                  />
                </Box>
              </Box>
              <Box sx={{ mt: 2 }}>
                <Skeleton
                  variant="rectangular"
                  height={10}
                  width="100%"
                  sx={{ borderRadius: 1 }}
                  animation="pulse"
                />
                <Skeleton
                  variant="text"
                  width="30%"
                  height={15}
                  sx={{ mt: 1 }}
                  animation="pulse"
                />
              </Box>
            </Box>
          ))
        ) : subscriptions?.length > 0 ? (
          subscriptions?.map((service, index) => (
            <Box
              key={index}
              sx={{
                backgroundColor: mode === "light" ? "#fff" : "##141414",
                border: `1px solid ${mode === "light" ? "#e5e7eb" : "#2E2E2E"}`,
                borderRadius: "12px",
                width: "100%",
                px: { xs: 2, sm: 2 },
                pt: { xs: 2, sm: 3 },
                pb: 2,
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              <CardContent sx={{ p: 0 }}>
                {/* Image + Title Row */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: { xs: 2, sm: 3 },
                    mb: { xs: 1.5, sm: 2 },
                  }}
                >
                  {/* Icon Container */}
                  <Box
                    sx={{
                      width: { xs: 50, sm: 80 },
                      height: { xs: 50, sm: 80 },
                      borderRadius: "10px",
                      border: `1px solid ${
                        mode === "light" ? "#d1d5db" : "#2E2E2E"
                      }`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Image
                      cdn={
                        service?.type === "file"
                          ? "files/logo/2025/clikkle%20files.png"
                          : service?.type === "esign"
                          ? "e-sign/logo/2025/clikkle%20esign.png"
                          : service?.type === "projects"
                          ? "projects/logo/2025/clikkle%20projects.png"
                          : service?.type === "worksuite"
                          ? "worksuite/2025/clikkle%20worksuite.png"
                          : service?.type === "campaigns"
                          ? "campaigns/logo/2025/clikkle%20campaigns.png"
                          : service?.type === "chat"
                          ? "chat/logo/2025/clikkle%20chat.png"
                          : "hr/logo/2025/clikkle%20hr.png"
                      }
                      alt={`${service.name} Icon`}
                      style={{
                        width: "80%",
                        height: "80%",
                        objectFit: "contain",
                      }}
                    />
                  </Box>

                  {/* Title and Price */}
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        fontSize: { xs: "1rem", sm: "1.3rem" },
                        color: mode === "light" ? "#000" : "#fff",
                      }}
                    >
                      {service.type === "file"
                        ? "Clikkle Files"
                        : service.type === "esign"
                        ? "Clikkle E-sign"
                        : service.type === "projects"
                        ? "Clikkle Projects"
                        : service.type === "worksuite"
                        ? "Clikkle Worksuite"
                        : service.type === "campaigns"
                        ? "Clikkle Campaigns"
                        : service.type === "chat"
                        ? "Clikkle Chat"
                        : "Clikkle Hr"}
                    </Typography>
                    {service?.orgName ? (
                      <Typography
                        sx={{
                          fontWeight: "medium",
                          fontSize: { xs: "0.5rem", sm: "0.8rem" },
                          color: mode === "light" ? "#000" : "#fff",
                        }}
                      >
                        <span style={{ fontWeight: "lighter" }}>OrgName: </span>
                        {service?.orgName ? service?.orgName : ""}
                      </Typography>
                    ) : (
                      <></>
                    )}

                    {service?.plan ? (
                      <Typography
                        sx={{
                          color: "#A5A5A5",
                          fontSize: { xs: "0.8rem", sm: "1rem" },
                        }}
                      >
                        $
                        {Number(service?.amount)?.toFixed(2) +
                          "/" +
                          service?.plan?.interval}
                      </Typography>
                    ) : (
                      <></>
                    )}
                    {service?.plan?.name !== "Free" &&
                      service?.plan?.name !== "Starter" && (
                        <Typography
                          sx={{
                            color: "#A5A5A5",
                            fontSize: { xs: "0.75rem", sm: "0.8rem" },
                          }}
                        >
                          Next subscription:{" "}
                          {moment(service?.startDate)
                            .add(1, service?.interval)
                            .format("MMMM D, YYYY")}
                        </Typography>
                      )}
                    <Typography
                      sx={{
                        color: "#A5A5A5",
                        fontSize: { xs: "0.75rem", sm: "0.8rem" },
                      }}
                    >
                      Plan: {service?.plan?.name}
                    </Typography>
                    {/* <Typography
                    sx={{
                      color: "#A5A5A5",
                      fontSize: { xs: "0.75rem", sm: "0.8rem" },
                    }}
                  >
                    Organization: {service?.name}
                  </Typography> */}
                  </Box>
                </Box>

                {/* Features */}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    mt: { xs: 2, sm: 4 },
                    fontSize: { xs: "0.9rem", sm: "1.1rem" },
                  }}
                >
                  Your plan includes:
                </Typography>
                <List sx={{ pl: 0 }}>
                  {service?.plan?.permission
                    ?.filter((item) => item.isPermission)
                    ?.map((feature, i) => (
                      <ListItem key={i} sx={{ py: 0.5, px: 0 }}>
                        <ListItemText
                          primary={
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                fontSize: "12px",
                              }}
                            >
                              <CheckIcon size={14} /> {feature?.content}
                            </span>
                          }
                          primaryTypographyProps={{
                            fontSize: { xs: "0.75rem", sm: "0.9rem" },
                            color: "#A5A5A5",
                          }}
                        />
                      </ListItem>
                    ))}
                </List>
              </CardContent>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: 2,
                  mt: 2,
                  flexWrap: "wrap", // In case buttons don't fit in one line
                }}
              >
                {service?.plan?.name !== "Free" &&
                  service?.plan?.name !== "Starter" && (
                    <Button
                      disabled={cancelledLoading}
                      onClick={() => cancelledSubscriptions(service?._id)}
                      variant="outlined"
                      sx={{
                        width: { xs: "auto", sm: "70%" },
                        fontSize: { xs: "0.7rem", sm: "0.875rem" },
                        borderColor: "#FF5353",
                        color: "#FF5353",
                        py: { xs: 0.5, sm: 1 },
                        ":hover": {
                          backgroundColor: "rgba(255, 0, 0, 0.1)",
                          borderColor: "#FF5353",
                        },
                      }}
                    >
                      {cancelledLoading ? "Loading..." : "Cancel Subscription"}
                    </Button>
                  )}

                {(service?.plan?.name !== "Enterprise" ||
                  service?.plan?.name !== "Platinum" ||
                  service?.plan?.name !== "Professional Plus" ||
                  service?.plan?.name !== "Professional Plus") && (
                  <Button
                    variant="contained"
                    size={isMobile ? "small" : "medium"}
                    sx={{
                      backgroundColor: "#3767B1",
                      color: "white",
                      fontSize: isMobile ? "1rem" : "1rem",
                      minWidth: isMobile ? "100px" : "auto",
                      borderRadius: "8px",
                      "&:hover": {
                        backgroundColor: "#1E40AF",
                      },
                      padding: "8px 25px",
                      fontWeight: 500,
                    }}
                    onClick={() => {
                      service.type === "hr"
                        ? navigate(
                            `/subscription/hr/purchase/${service?.orgId}`
                          )
                        : service.type === "esign"
                        ? navigate("/subscription/esign/purchase")
                        : service.type === "projects"
                        ? navigate(
                            `/subscription/projects/purchase/${service?.orgId}`
                          )
                        : navigate("/subscription/files/purchase");
                    }}
                  >
                    Upgrade
                  </Button>
                )}
              </Box>
            </Box>
          ))
        ) : (
          <>
            <Box
              width="100%"
              display="flex"
              justifyContent="center"
              flexDirection="column"
              alignItems="center"
              height="300px"
              gridColumn="1 / -1"
              textAlign="center"
              sx={{ color: "#888" }}
            >
              <Typography variant="h6">No Active Subscription Found</Typography>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Active;
